import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { GetCollectionDetailsInput, GetCollectionDetailsOutput } from "types/web-app";

export const getCollectionDetails = async (
  accessToken: string,
  input: GetCollectionDetailsInput
) => {
  try {
    const response = await fetchWithAuth(
      `/collection/details?collection_id=${input.collection_id}`,
      accessToken,
      {
        method: "GET",
      }
    );
    const data = (await response.json()) as ServiceResponse<GetCollectionDetailsOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
